import React, { useEffect, useMemo, useState } from 'react';
import HeadTitle from '../../components/HeadTitle';
import HeaderStats from '../../components/report/ReportHeader.js';
import ReportTable from '../../components/report/ReportTable';
import SearchFilter from '../../components/analytics-and-insights/SearchFilter';
import { useSelector } from 'react-redux';
import {
  fetchUserData,
  fetchUsersList,
  fetchVerificationData,
} from '../../api/user';
import { fetchReportStats, fetchReportUsersList } from '../../api/report'

const statsData = [
  {
    title: 'Total Report Requests',
    totalCount: 0,
    fixedColor: '#007bff',
  },
  {
    title: 'Resolved Requests',
    totalCount: 0,
    fixedColor: '#28a745',
  },
  {
    title: 'Pending Requests',
    totalCount: 0,
    fixedColor: '#ffc107',
  },
];

const VerificationRequest = () => {
  // const { filter } = useSelector((state) => state);
  const filter = useSelector((state) => state.filter);
  const filterWithoutUTM = useMemo(() => {
    const { utm_options, ...rest } = filter;
    return rest;
  }, [JSON.stringify(filter)]);
  const [userData, setUserData] = useState([]);
  const [filteredData, setFilteredData] = useState(userData);
  const [verificationData, setVerificationData] = useState({});
  const [stats, setStats] = useState(statsData);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageLimit, setPageLimit] = useState(25);
  const [totalPages, setTotalPages] = useState(0);
  const [loading, setLoading] = useState(false);
  const [searchTerm, setSearchTerm] = useState(null);
  const [initialLoad, setInitialLoad] = useState(false)
  const [groupBy, setGroupBy] = useState('reportedUser')


  const [components] = useState([
    {
      id: 1,
      imageSrc: '/assets/images/admin-panel/clipboard.png',
      text: 'Report ',
      description:
        'Informed about platform updates, upcoming features, policy changes, events, and other important information',
    },
  ]);

const handleFilterChange = (statusFilter) => {
  if (!userData || userData.length === 0) {
    setFilteredData([]);
    return;
  } 
  if (statusFilter === 'All') {
    setFilteredData(userData);
    return;
  } 
  const filteredUsers = userData
    .map((user) => {
      const reports = Array.isArray(user.reports) ? user.reports : [];
      const filteredReports = reports.filter(
        (report) => report.status === statusFilter
      );
      if (filteredReports.length === 0) return null; // Exclude users with no matching reports
      return {
        ...user,
        reports: filteredReports,
        totalCount: filteredReports.length, // update totalCount to match filtered set
      };
    })
    .filter(Boolean); // remove nulls (users without matching reports)

  setFilteredData(filteredUsers);
};

  const fetchData = async () => {
    try {
      setLoading(true);
      await fetchReportStats(filter, setVerificationData);
      const data = await fetchReportUsersList({
        filter,
        setReportUsersData: setUserData,
        page: currentPage,
        limit: pageLimit,
        skip: 0,
        verification: true,
        isBot: false,
        searchTerm,
        groupBy: groupBy
      });
      // setTotalUsers(data.totalUsersCount);
      setTotalPages(data?.pagination?.pages ?? 0);
    } catch (error) {
      console.error('Error while loading real-time data', error);
    } finally {
      setLoading(false);
    }
  };

  const handlePageChange = (event, page) => {
    setCurrentPage(page);
  };

  useEffect(() => {
    fetchData().finally(fin => setInitialLoad(true))
  }, [JSON.stringify(filterWithoutUTM), currentPage]);

  // useEffect(() => {
  //   setFilteredData(userData);
  // }, [userData]);

  useEffect(() => {
    if (Object.keys(verificationData).length !== 0) {
      const response = verificationData;
      const updatedStats = statsData.map((stat) => {
        switch (stat.title) {
          case 'Total Report Requests':
            return {
              ...stat,
              totalCount: response.totalReports
            };
          case 'Pending Requests':
            return {
              ...stat,
              totalCount: response.pendingReports

            };
          case 'Resolved Requests':
            return {
              ...stat,
              totalCount: response.resolvedReports

            };
          default:
            return stat;
        }
      });

      setStats(updatedStats);
    }
  }, [verificationData]);

  const handleSearch = () => {
    fetchData()
  }

  return (
    <div>
      {/* Dynamically Render Components */}
      {components.map((component) => (
        <HeadTitle
          key={component.id}
          imageSrc={component.imageSrc}
          text={component.text}
          description={component.description}
        />
      ))}

      {/* <SearchFilter /> */}

      <HeaderStats
        stats={stats}
        data={userData}
        onFilterChange={handleFilterChange}
      />
      <ReportTable
        initialLoad={initialLoad}
        data={filteredData.length>0 ? filteredData : userData}
        totalPages={totalPages}
        currentPage={currentPage}
        handlePageChange={handlePageChange}
        itemsPerPage={pageLimit}
        loading={loading}
        searchTerm={searchTerm}
        setSearchTerm={setSearchTerm}
        handleSearch={handleSearch}
        fetchData={fetchData}
        groupby={groupBy}
        setGroupBy={setGroupBy}
      />
    </div>
  );
};

export default VerificationRequest;
